import { useSetAtom } from 'jotai';
import { useCallback } from 'react';
import {
    hdeRegistrationModalIsOpenAtom,
    hdeRegistrationModalLocationOptionsAtom,
} from './HDERegistrationModal';
import type { LocationOption } from './types';

export function useHDERegistrationModal() {
    const setIsOpen = useSetAtom(hdeRegistrationModalIsOpenAtom);
    const setLocationOptions = useSetAtom(
        hdeRegistrationModalLocationOptionsAtom,
    );

    const openModal = useCallback(
        (locationOptions: LocationOption[] = []) => {
            setLocationOptions(locationOptions);
            setIsOpen(true);
        },
        [setIsOpen, setLocationOptions],
    );

    return { openModal };
}
